<template>
  <div class="min-h-screen bg-[#0f172a] overflow-hidden">

     <button
      type="button"
      data-mdb-ripple="true"
      data-mdb-ripple-color="light"
      @click="backToTop"
      class="inline-block z-10 p-3 hover:scale-105 transition-all  bg-yellow-400 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover: bg-yellow-400 hover:shadow-lg focus: bg-yellow-400  focus:shadow-lg focus:outline-none focus:ring-0 active: bg-yellow-400  active:shadow-lg transition duration-150 ease-in-out bottom-5 right-5"
      id="btn-back-to-top"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        class="w-4 h-4"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill="currentColor"
          d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ></path>
      </svg>
    </button>

     <!-- ================= NAVBAR ================= -->
    <Popover
      :class="[
        'fixed w-full top-0 left-0 z-50 transition-all duration-300',
        scrolled
          ? 'bg-[#0f172a]/90 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      ]"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between py-4">

          <!-- Logo -->
          <router-link to="/" class="flex items-center gap-2">
            <img class="h-9 w-auto" src="../assets/logo11.png" alt="oillead" />
            <div class="leading-tight">
              <div class="text-sm font-extrabold text-white">
                OIL<span class="text-yellow-400">L</span>EAD
              </div>
              <div class="text-xs font-bold tracking-wide text-yellow-400">
                SERVICES
              </div>
            </div>
          </router-link>

          <!-- Desktop Nav -->
          <PopoverGroup class="hidden lg:flex items-center gap-10">
            <router-link to="/" class="nav-link">HOME</router-link>
            <router-link to="/about" class="nav-link">ABOUT US</router-link>
            <router-link to="/services"  class="nav-link">SERVICES</router-link>
            <router-link to="/projects"  class="nav-link">PROJECTS</router-link>
            <router-link to="/contact"  class="nav-link">CONTACT US</router-link>
          </PopoverGroup>

          <!-- Mobile Button -->
          <div class="lg:hidden">
            <PopoverButton
              class="rounded-md p-2 text-white hover:bg-white/10 transition"
            >
              ☰
            </PopoverButton>
          </div>
        </div>
      </div>

      <!-- ================= MOBILE MENU ================= -->
      <transition
        enter-active-class="duration-200 ease-out"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-150 ease-in"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <PopoverPanel
          v-slot="{ close }"
          focus
          class="absolute z-50 top-0 inset-x-0 p-4 transform origin-top-right lg:hidden"
        >
          <div class="rounded-2xl shadow-2xl
                      bg-[#0f172a]/95 backdrop-blur-xl
                      border border-white/10">

            <div class="flex items-center justify-between px-6 py-5 border-b border-white/10">


                <div class="text-sm flex gap-2 font-bold text-white" >
                  <PopoverButton
                    class="flex items-center outline-none ring-0 focus:outline-none focus:ring-0 active:ring-0 border-0"
                    >
                    <img class="h-8 w-auto sm:h-10" src="../assets/logo11.png" alt="" />
                    </PopoverButton>
                   <div class="leading-tight">
                        <div class="text-sm font-extrabold text-white">
                            OIL<span class="text-yellow-400">L</span>EAD
                        </div>
                        <div class="text-xs font-bold tracking-wide text-yellow-400">
                            SERVICES
                        </div>
                    </div>
                </div>


              

              <PopoverButton
                class="rounded-md p-2 text-white hover:bg-white/10 transition"
              >
                ✕
              </PopoverButton>
            </div>

             <div class="px-6 py-6 flex flex-col items-center text-center gap-6">
                <router-link to="/" class="nav-link" @click="close">HOME</router-link>
                <router-link to="/about" class="nav-link" @click="close">ABOUT US</router-link>
                <router-link to="/services" class="nav-link" @click="close">SERVICES</router-link>
                <router-link to="/projects" class="nav-link" @click="close">PROJECTS</router-link>
                <router-link to="/contact" class="nav-link" @click="close">CONTACT US</router-link>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>

    <!-- ================= CONTACT SCREEN ================= -->
    <main class="pt-28 min-h-[100svh] flex items-center">
      <div class="max-w-7xl mx-auto px-6 w-full">

        <!-- ===== DESKTOP / TABLET VIEW ===== -->
        <div class="hidden md:grid md:grid-cols-2 gap-20 items-center">

          <!-- LEFT CONTENT -->
          <div>
            <span class="text-xs tracking-[0.35em] font-bold text-[#facc15]">
              CONTACT US
            </span>

            <h1 class="mt-6 text-3xl lg:text-5xl font-extrabold text-white leading-tight">
              Get in Touch With<br />
              Oillead Services
            </h1>

            <p class="mt-6 text-lg leading-8 text-gray-300 max-w-xl">
              We engage with clients across engineering design, procurement,
              construction, and commissioning. Our team is available to discuss
              technical requirements, partnerships, and project execution.
            </p>

            <div class="mt-10">
              <a
                href="mailto:info@oilleadservices.com.ng"
                class="inline-flex items-center gap-2
                       bg-[#facc15] text-black
                       px-10 py-4 text-sm font-bold
                       hover:bg-yellow-400 transition"
              >
                Send a Message →
              </a>
            </div>
          </div>

          <!-- RIGHT CONTACT INFO -->
          <div class="space-y-12">
            <!-- Address -->
            <div>
              <h3 class="text-sm font-bold tracking-widest text-[#facc15] mb-4">
                OFFICE ADDRESS
              </h3>
              <p class="text-gray-300 leading-7">
                377a Omofade Crescent, Omole Phase 1<br />
                Ikeja, Lagos<br />
                Nigeria
              </p>
            </div>

            <!-- Phone -->
            <div>
              <h3 class="text-sm font-bold tracking-widest text-[#facc15] mb-4">
                PHONE
              </h3>
              <div class="space-y-2">
                <a
                  href="tel:+2348033735826"
                  class="block text-gray-300 hover:text-[#facc15] transition"
                >
                  +234 803 373 5826
                </a>
                <a
                  href="tel:+2348033010995"
                  class="block text-gray-300 hover:text-[#facc15] transition"
                >
                  +234 803 301 0995
                </a>
              </div>
            </div>

            <!-- Email -->
            <div>
              <h3 class="text-sm font-bold tracking-widest text-[#facc15] mb-4">
                EMAIL
              </h3>
              <a
                href="mailto:info@oilleadservices.com.ng"
                class="text-gray-300 hover:text-[#facc15] transition"
              >
                info@oilleadservices.com.ng
              </a>
            </div>
          </div>
        </div>

        <!-- ===== MOBILE VIEW ===== -->
        <div class="md:hidden flex flex-col items-center text-center gap-8">
          <span class="text-xs tracking-[0.35em] font-bold text-[#facc15]">
            CONTACT US
          </span>

          <h1 class="text-3xl font-extrabold text-white leading-snug">
            Get in Touch
          </h1>

          <p class="text-gray-300 text-base leading-6 max-w-xs">
            Contact us directly via phone, email, or visit our office.
          </p>

          <div class="space-y-4">
            <div>
              <p class="text-sm font-bold tracking-widest text-[#facc15] mb-1">OFFICE ADDRESS</p>
              <p class="text-gray-300 leading-6">377a Omofade Crescent, Omole Phase 1, Ikeja, Lagos, Nigeria</p>
            </div>

            <div>
              <p class="text-sm font-bold tracking-widest text-[#facc15] mb-1">PHONE</p>
              <p class="text-gray-300 leading-6">
                <a href="tel:+2348033735826" class="hover:text-[#facc15] transition">+234 803 373 5826</a><br/>
                <a href="tel:+2348033010995" class="hover:text-[#facc15] transition">+234 803 301 0995</a>
              </p>
            </div>

            <div>
              <p class="text-sm font-bold tracking-widest text-[#facc15] mb-1">EMAIL</p>
              <p class="text-gray-300 leading-6">
                <a href="mailto:info@oilleadservices.com.ng" class="hover:text-[#facc15] transition">
                  info@oilleadservices.com.ng
                </a>
              </p>
            </div>
          </div>

          <a
            href="mailto:info@oilleadservices.com.ng"
            class="inline-flex items-center gap-2
                   bg-[#facc15] text-black
                   px-8 py-3 text-sm font-bold
                   hover:bg-yellow-400 transition"
          >
            Send a Message →
          </a>
        </div>

      </div>
    </main>

       <!-- ================= FOOTER ================= -->
    <footer class="bg-slate-950 border-t border-slate-800 py-10 text-center text-gray-400">
      © 2026 OILLEAD SERVICES. All rights reserved.
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from "@headlessui/vue"

/* ================= NAVBAR SCROLL ================= */

const scrolled = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

 // your arrow scroll function
      function scrollFunction() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "block";
      } else {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "none";
      }
    }

    // your arrow scroll function
    function backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

onMounted(() => {
      // navabar scroll
      window.addEventListener("scroll", handleScroll);

      // your arrow onscroll
      window.onscroll = function () {
        scrollFunction();
      };
    });

    onUnmounted(() => {
      //navbar scroll
      window.removeEventListener("scroll", handleScroll);

      // cleanup arrow scroll
      window.onscroll = null;
    });

</script>

<style scoped>
.nav-link {
  font-size: 0.875rem;        /* text-sm */
  font-weight: 600;           /* font-semibold */
  letter-spacing: 0.05em;     /* tracking-wide */
  color: #ffffff;             /* text-white */
  cursor: pointer;            /* cursor-pointer */
  transition-property: color; /* transition-colors */
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

.nav-link:hover {
  color: #facc15; /* hover:text-yellow-400 */
}
</style>
